import {
  Quiz,
  Quiztonote,
  QuiztonoteEntity
} from '../../../graphql/generated/graphql';
import { ToRequiredType } from '../../../types/typeDef';
import { QuizToNoteDef } from '../../../types/quizToNote/quizToNote';

export const getQuizToNoteDefFromQuery: (
  quiztonote: Partial<QuiztonoteEntity>
) => QuizToNoteDef = quiztonote => ({
  ...((quiztonote as unknown) as ToRequiredType<Partial<Quiztonote>>),
  id: quiztonote?.id,
  note: quiztonote?.attributes?.note,
  quiz: {
    ...(quiztonote?.attributes?.quiz?.data?.attributes as ToRequiredType<
      Partial<Quiz>
    >),
    id: quiztonote?.attributes?.quiz?.data?.id
  }
});
